import { createRouter, createWebHistory } from 'vue-router'
import DocView from '../views/DocView.vue'
import DownloadPage from '../views/DownloadPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/docs/1'
  },
  {
    path: '/docs/:slug',
    name: 'DocView',
    component: DocView,
    props: true
  },
  {
    path: '/download',
    name: 'DownloadPage',
    component: DownloadPage,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
